var _defs, _path, _rect, _rect2, _rect3, _polygon, _circle, _circle2, _circle3, _circle4, _ellipse, _circle5, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.72 160.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdd5ea;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-width:0px;}.cls-2{fill:#a06044;}.cls-3{fill:#f5f6f7;}.cls-4{fill:#6d798e;}.cls-5{fill:#586478;}.cls-6{fill:#435063;}.cls-7{fill:#d6e5f2;}.cls-8{fill:#995436;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.02,38.02H46.83l6.63-9.79c2.45-3.61,6.53-5.77,10.89-5.77h32.15c4.36,0,8.44,2.16,10.89,5.77l6.63,9.79Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 16.02,
    y: 30.24,
    width: 16.04,
    height: 6.46,
    rx: 2.29,
    ry: 2.29
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 33.47,
    width: 160.72,
    height: 104.98,
    rx: 12.16,
    ry: 12.16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 51.73,
    width: 160.72,
    height: 68.46
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "160.72 95.55 160.72 120.19 75.4 120.19 80.36 54.18 96.47 51.73 106.54 50.2 108.38 51.73 160.72 95.55"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 80.36,
    cy: 85.96,
    r: 44.32,
    transform: "translate(-17.99 150.58) rotate(-80.24)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 80.36,
    cy: 85.96,
    r: 39.1,
    transform: "translate(-22.74 142.68) rotate(-75.74)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 80.36,
    cy: 85.96,
    r: 31.78,
    transform: "translate(-25.25 34.07) rotate(-20.76)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 80.36,
    cy: 85.96,
    r: 16.33
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 65.48,
    cy: 73.64,
    rx: 13.58,
    ry: 10.07,
    transform: "translate(-31.83 58.14) rotate(-39.31)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 89.94,
    cy: 99.79,
    r: 10.07,
    transform: "translate(-18.16 179.55) rotate(-84.39)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.87,43.23h-8.44c-1.6,0-2.9-1.3-2.9-2.9h0c0-1.6,1.3-2.9,2.9-2.9h8.44c1.6,0,2.9,1.3,2.9,2.9h0c0,1.6-1.3,2.9-2.9,2.9Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCamera);
export default __webpack_public_path__ + "static/media/Icons_Camera.fbcb3e577fcd33d5d2597368f263e408.svg";
export { ForwardRef as ReactComponent };